import { Component, Input } from '@angular/core';
import { CommonModule, formatDate } from '@angular/common';
import { convertToAESTDateTime, formatDateAEST, getLastUpdatedDescription } from '../utils';

@Component({
	// standalone : true,
	selector: 'app-last-updated-widget',
	templateUrl: './last-updated-widget.component.html',
	styleUrls: ['./last-updated-widget.component.scss'],
	// imports : [CommonModule]	
})
export class LastUpdatedWidgetComponent {  
	@Input() alignPillRight : boolean= false;
    @Input() label : string;
	@Input() labelBold : boolean = false;
	@Input() tagColourNSWDark : boolean = false;
    @Input() updatedDate : string | Date | undefined;
	@Input() dateOutFormat = "ccc, dd/L/yy";
	

    get updatedDateDesc() : string {

		let dtStr = "";
		try
		{
			if(this.updatedDate)
			{				
				const dt = convertToAESTDateTime(this.updatedDate) ?? this.updatedDate; // new Date(Date.parse(this.updatedDate?.toString()));

				dtStr = dt && "function" === typeof(dt.getDate) 
					? formatDateAEST(dt, this.dateOutFormat) : "";								
			}	
			
		}
		catch(ex) 
		{

		}

		return dtStr;    	
    }
}

